// Browsers can suspend/throttle a backgrounded tab's AudioContext to varying,
// unpredictable degrees (there is no single documented guarantee across
// Chrome/Firefox/Safari/Android WebView) — with nothing to repair it,
// interacting with audio after returning to a backgrounded tab can look
// "frozen" until some OTHER action happens to route through a resume-if-
// suspended check already present in most play()/start() methods. This
// resumes the given context the moment the tab becomes visible again,
// independent of any user action, so returning to the app is never a dead
// end. PlaybackController (src/audio/PlaybackController.ts) has its own,
// more involved version of this same idea (it also repairs a stalled
// pre-roll countdown) — this is the lightweight version for the other two
// AudioContext owners (the standalone Metronome tab, the Song Library's
// marker/click preview player), which have no equivalent stateful countdown
// to repair, only the context itself to resume.
export function resumeAudioContextOnVisible(getContext: () => AudioContext | null): () => void {
  const handler = () => {
    if (document.visibilityState !== 'visible') return;
    const context = getContext();
    if (context && context.state === 'suspended') void context.resume();
  };
  document.addEventListener('visibilitychange', handler);
  return () => document.removeEventListener('visibilitychange', handler);
}
